import { combineReducers } from 'redux'
import connection from './connection'

export default combineReducers({
  connection,
})
